import type { VoiceMessage } from '@orborix/voice-client';
import { IconArrow } from '../leveling/icons.js';
import '../leveling/leveling.css';

/**
 * Banner de progreso del examen de nivelación. Vive entre el header y los
 * mensajes (mismo lugar que MissionTracker en escenarios). Da dos cosas que
 * faltaban: cuántas preguntas quedan, y un cierre claro — cuando el coach
 * llega al cierre (~turno 6) el botón pasa a "Ver mi nivel".
 *
 * El prompt del examen cierra entre el turno 6 y 7 (ver calibration.ts). No
 * cortamos la charla a mitad: ofrecemos el cierre, el user decide cuándo.
 */
const EXAM_TARGET_TURNS = 6;

interface ExamProgressProps {
  messages: ReadonlyArray<VoiceMessage>;
  onFinish: () => void;
}

export function ExamProgress({ messages, onFinish }: ExamProgressProps) {
  const coachTurns = messages.filter((m) => m.who === 'bot' && !m.historical).length;
  const current = Math.max(1, Math.min(coachTurns, EXAM_TARGET_TURNS));
  const pct = Math.min(coachTurns / EXAM_TARGET_TURNS, 1) * 100;
  const ready = coachTurns >= EXAM_TARGET_TURNS;

  return (
    <div className="exam-bar">
      <div className="exam-bar-row">
        <div className="exam-bar-info">
          <span className="exam-bar-title">Examen de nivel</span>
          <span className="exam-bar-count">
            {ready ? 'Listo cuando quieras' : `Pregunta ${current} de ~${EXAM_TARGET_TURNS} · charlá tranquilo`}
          </span>
        </div>
        <button
          type="button"
          className={`exam-bar-finish ${ready ? 'is-ready' : ''}`}
          onClick={onFinish}
        >
          {ready ? (
            <>
              Ver mi nivel <IconArrow size={15} />
            </>
          ) : (
            'Terminar'
          )}
        </button>
      </div>
      <div className="exam-bar-track">
        <div className="exam-bar-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
